export default __webpack_public_path__ + "static/media/flip_horizontal.24a37367.svg";